import React from "react";
import styles from "../style.module.scss";
import { Button, MenuProps } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { VLDropdown } from "../../VLDropdown/VLDropdown";

export interface TableActionProps {
  menuItems: MenuProps["items"];
}

export default function TableAction({ menuItems }: TableActionProps) {
  if (!menuItems || menuItems.length === 0) return null;

  return (
    <VLDropdown
      menu={{ items: menuItems }}
      placement={"bottomLeft"}
      trigger={["click"]}
    >
      <Button
        type="text"
        size="small"
        icon={<MoreOutlined className={styles.actionsIcon} />}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
    </VLDropdown>
  );
}
